import { downloadFileEndpoint } from 'constants/index';

const downloadFile = async (testId: string, questionId: string) => {
  const res = await fetch(`${downloadFileEndpoint}?testId=${testId}&questionId=${questionId}`);
  const { link } = await res.json();
  window.open(link);
};

export default downloadFile;
